import type { CustomerSelectorContactResult } from './CustomerSelector';

export function needsLocationSelection(
  contact: Pick<CustomerSelectorContactResult, 'childCount' | 'parentContactId'>,
): boolean {
  return !contact.parentContactId && (contact.childCount ?? 0) > 0;
}
